// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/ao_temporal_filter.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'ao_temporal_filterPixelShader';
const shader = `#ifdef GL_ES
#endif
precision highp float;
varying vec2 vUV;
uniform highp sampler2D depthSampler;
uniform sampler2D aoSampler;
uniform highp sampler2D previousDepthSampler;
uniform sampler2D previousAoSampler;
uniform mat4 invertedProjectionMatrix;
uniform mat4 previousProjectedToCurrentView;
uniform mat4 viewToPreviousProjMatrix;
uniform mat4 inverseViewMatrix;
uniform vec2 projectionMatrixZ;
uniform vec2 previousProjectionMatrixZ;
#define LINEAR_DEPTH
vec3 viewSpacePositionFromDepth(float z, float u, float v)
{
#ifdef LINEAR_DEPTH
float x = u * 2.0 - 1.0;
float y = v * 2.0 - 1.0;
vec4 vProjectedPos = vec4(x, y, 1.0, 1.0);
vec4 farViewspacePosition = invertedProjectionMatrix * vProjectedPos;
vec3 viewDirection = normalize(farViewspacePosition.xyz);
return viewDirection * z / viewDirection.z;
#else
float x = u * 2.0 - 1.0;
float y = v * 2.0 - 1.0;
vec4 vProjectedPos = vec4(x, y, z * 2.0 - 1.0, 1.0);
vec4 viewspacePosition = invertedProjectionMatrix * vProjectedPos;
return viewspacePosition.xyz / viewspacePosition.w;
#endif
}
void main(void)
{
float pixelDepthValue = texture2D(depthSampler, vUV).r;
if (pixelDepthValue < 0.0) {
gl_FragColor = vec4(0, 0, 0, 1);
return;
}
vec3 viewSpacePosition = viewSpacePositionFromDepth(pixelDepthValue, vUV.x, vUV.y);
vec4 previousProjection = viewToPreviousProjMatrix * vec4(viewSpacePosition, 1.0);
float ao = texture2D(aoSampler, vUV).r;
previousProjection = previousProjection / previousProjection.w;
vec2 previousUv = previousProjection.xy * 0.5 + 0.5;
if(previousUv.x < 0.0 || previousUv.y < 0.0 || previousUv.x >= 1.0 || previousUv.y >= 1.0) {
} else {
float previousDepthLinear = texture2D(previousDepthSampler, previousUv).r;
if (previousDepthLinear > 0.0) {
float A = previousProjectionMatrixZ.x;
float B = previousProjectionMatrixZ.y;
float previousDepthNonLinear = 0.5 * (A * previousDepthLinear + B) / previousDepthLinear + 0.5;
vec4 reprojectedViewSpace = previousProjectedToCurrentView * vec4(previousProjection.xy, previousDepthNonLinear * 2.0 - 1.0, 1.0);
reprojectedViewSpace /= reprojectedViewSpace.w;
float weight = length(reprojectedViewSpace.xyz - viewSpacePosition.xyz) * 9.0;
float previousAo = texture2D(previousAoSampler, previousUv).r;
weight += abs(previousAo - ao) * 2.0;
weight = clamp(weight, 1.0 / 16.0, 1.0);
ao = mix(previousAo, ao, weight);
}
}
gl_FragColor = vec4(ao, 0, 0, 1);
}
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ao_temporal_filterPixelShader = { name, shader };
//# sourceMappingURL=ao_temporal_filter.fragment.js.map